import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const WhyLandLayout = () => {
  const { t } = useLanguage();
  
  return (
    <div className="max-w-7xl mx-auto px-4 py-8 sm:py-12 md:py-16 lg:py-20">
      {/* Header */}
      <div className="flex justify-center font-montserrat mb-8 sm:mb-12">
        <div className="text-center">
          {/* Green Bar Above Header */}
          <div className="w-16 h-1 bg-brand-green mb-2 mx-auto"></div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl flex items-center justify-center">
            {t('whyLandLayout.title')}
          </h2>
        </div>
      </div>

      {/* Three Columns Layout */}
      <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 sm:gap-8 font-montserrat">
        {/* Explore Land Column */}
        <div className="bg-brand-green rounded-3xl p-6 sm:p-8 md:p-10 lg:p-12 text-white relative overflow-hidden">
          {/* Content */}
          <div className="relative z-10">
            <div className="relative mb-6 sm:mb-8 mt-2">
              {/* Background Text */}
              <div className="absolute -top-7 left-1 text-3xl sm:text-4xl md:text-5xl font-bold opacity-10 whitespace-nowrap pointer-events-none">
                {t('whyLandLayout.exploreLand.title')}
              </div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold relative z-10">{t('whyLandLayout.exploreLand.title')}</h3>
            </div>

            <div className="space-y-6 sm:space-y-8">
              <Feature
                title={t('whyLandLayout.exploreLand.exploreWithClarity')}
                description={t('whyLandLayout.exploreLand.exploreWithClarityDesc')}
              />
              <Feature
                title={t('whyLandLayout.exploreLand.understandBeforeVisit')}
                description={t('whyLandLayout.exploreLand.understandBeforeVisitDesc')}
              />
              <Feature
                title={t('whyLandLayout.exploreLand.saveTravelTime')}
                description={t('whyLandLayout.exploreLand.saveTravelTimeDesc')}
              />
            </div>
          </div>
        </div>

        {/* Share Land Column */}
        <div className="p-6 sm:p-8 md:p-10 lg:p-12 bg-gray-50 rounded-3xl relative overflow-hidden">
          {/* Content */}
          <div className="relative z-10">
            <div className="relative mb-6 sm:mb-8 mt-2">
              {/* Background Text */}
              <div className="absolute -top-7 left-1 text-3xl sm:text-4xl md:text-5xl font-bold opacity-10 whitespace-nowrap pointer-events-none">
                {t('whyLandLayout.shareLand.title')}
              </div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 relative z-10">{t('whyLandLayout.shareLand.title')}</h3>
            </div>

            <div className="space-y-6 sm:space-y-8">
              <Feature
                title={t('whyLandLayout.shareLand.showYourLandClearly')}
                description={t('whyLandLayout.shareLand.showYourLandClearlyDesc')}
                light
              />
              <Feature
                title={t('whyLandLayout.shareLand.publicOrPrivate')}
                description={t('whyLandLayout.shareLand.publicOrPrivateDesc')}
                light
              />
              <Feature
                title={t('whyLandLayout.shareLand.shareWithAnyone')}
                description={t('whyLandLayout.shareLand.shareWithAnyoneDesc')}
                light
              />
            </div>
          </div>
        </div>

        {/* Monitor Land Column */}
        <div className="bg-brand-blue rounded-3xl p-6 sm:p-8 md:p-10 lg:p-12 text-white md:col-span-2 lg:col-span-1 relative overflow-hidden">
          {/* Content */}
          <div className="relative z-10">
            <div className="relative mb-6 sm:mb-8 mt-2">
              {/* Background Text */}
              <div className="absolute -top-7 left-1 text-3xl sm:text-4xl md:text-5xl font-bold opacity-10 whitespace-nowrap pointer-events-none">
                {t('whyLandLayout.monitorLand.title')}
              </div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold relative z-10">{t('whyLandLayout.monitorLand.title')}</h3>
            </div>

            <div className="space-y-6 sm:space-y-8">
              <Feature
                title={t('whyLandLayout.monitorLand.stayUpdated')}
                description={t('whyLandLayout.monitorLand.stayUpdatedDesc')}
              />
              <Feature
                title={t('whyLandLayout.monitorLand.preventEncroachment')}
                description={t('whyLandLayout.monitorLand.preventEncroachmentDesc')}
              />
              <Feature
                title={t('whyLandLayout.monitorLand.peaceOfMind')}
                description={t('whyLandLayout.monitorLand.peaceOfMindDesc')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Feature = ({ title, description, light = false }) => (
  <div className="flex items-start gap-3">
    <div>
      <h4 className={`font-medium text-lg mb-1 ${light ? 'text-gray-800' : 'text-white'}`}>
        {title}
      </h4>
      <p className={light ? 'text-gray-600' : 'text-white/80'}>
        {description}
      </p>
    </div>
  </div>
);

export default WhyLandLayout;
